import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import Header from '../partials/Header/Header';
import HeaderDateMonths from '../partials/HeaderDateMonths/HeaderDateMonths';
import ProductsSwiper from '../partials/ProductsSwiper/ProductsSwiper';
import Updates from '../partials/Updates/Updates';
import ProductAccount from '../partials/ProductAccount/ProductAccount';
import {
  getInvoiceDataBySectionSubscriberNoAsync,
  getInvoiceDataAsync,
  getPdfLogAuthAsync,
  getPdfAuthCheckLoginAsync,
  getCallsLogAuthAsync,
} from '../PersonalAreaInvoicesAsyncThunk';
import {
  goToPage,
  setGuidId,
  setSelectedBan,
  setDetailsProducts,
  setCallsDetailsPopUp,
  closeIdentificationPopUp,
  setShowAnnualInvoicePopup,
} from '../PersonalAreaInvoicesSlice';
import DetailsMonthlyCharges from '../partials/Detailsmonthlycharges/Detailsmonthlycharges';
import Footer from '../partials/footer/fotter';
import AdditionalInvoices from '../partials/AdditionalInvoices/AdditionalInvoices';
import ButtonBar from '../partials/ButtonBar/ButtonBar';
import Popup from '../../../Shared/Popup/PopUp';
import IdValidationPopup from '../../../Block/OTPLoginBlock/Popups/idValidationPopup';
import {isMobile} from 'react-device-detect';
import CallDetailsPopUp from '../partials/CallsDetails/CallDetailsPopUp/CallDetailsPopUp';
import IdentificationPopUp from '../partials/IdentificationPopUp/IdentificationPopUp';
import {IdentificationActionEnum} from '../Constant';
import {buildUrlAndOpenSameWindow} from '../../../../utilities/StringHelpers/StringHelpers';
import authenticationProvider from '../../../../utilities/authentication/authenticationProvider';
import AnnualInvoiceConsolidationPopup from '../partials/AnnualInvoiceConsolidationPopup/AnnualInvoiceConsolidationPopup';

function InvoicesPage(props) {
  const [isSticky, setSticky] = useState(false);
  const [showIDPopup, setShowIDPopUp] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState('');
  const {isFullAuthenticated, isOtpAuthenticated, isOtpExtendedAuthenticated} = props.authentication?.loginData || {};
  const isAuthenticated = isFullAuthenticated || isOtpAuthenticated || isOtpExtendedAuthenticated;
  const isAuthorizationHeader = props.epiData.isDisplayFullAuthorizationHeader && isAuthenticated;

  const handleScroll = () => {
    const headerHeight = isMobile ? 220 : 400;
    if (window.scrollY > headerHeight) {
      setSticky(true);
    } else {
      setSticky(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const closeModalIdPopup = () => {
    setShowIDPopUp(false);
    buildUrlAndOpenSameWindow(redirectUrl);
  };

  async function handleOnClickBan(ban) {
    if (ban) {
      if (!isSticky) {
        props.setGuidId(ban.guidId);
        props.setSelectedBan(ban);
        props.getInvoiceDataAsync({guidId: ban.guidId});
      }
    } else {
      //CLICK ON THE BUTTON SEE ALL INVOICES
      const redirectUrl = location.pathname + location.search;
      setSessionStorage();
      authenticationProvider.redirectToLogin(redirectUrl, redirectUrl, '');
    }
  }

  function setSessionStorage() {
    const data = {
      id: props.guidId,
    };
    sessionStorage.setItem('invoiceIframeData', JSON.stringify(data));
  }

  function handleOnClickUpdateMailing() {
    localStorage.setItem('invoiceSelectedBan', props.selectedBan.ban);
    window.open(props.epiData.updateMailingLink, '_self');
  }

  function handleOnClickIdentificationButton(form) {
    switch (props.identificationPopUp.actionAfterLogin) {
      case IdentificationActionEnum.DISPLAY_TAX_INVOICE:
      case IdentificationActionEnum.DISPLAY_ACCESSIBLE_INVOICE:
      case IdentificationActionEnum.DISPLAY_ANNUAL_INVOICE_CONSOLIDATION:
        props.getPdfAuthCheckLoginAsync({form: form});
        break;
      case IdentificationActionEnum.DISPLAY_CALLS_DETAILS:
        break;
      default:
        break;
    }
  }

  function handleOnClickButtonBar(type, guid, systemSourcePDF) {
    switch (type) {
      case IdentificationActionEnum.DISPLAY_ANNUAL_INVOICE_CONSOLIDATION:
        props.getPdfLogAuthAsync({isConsolidationPdf: true, systemSourcePDF});
        break;
      case IdentificationActionEnum.DISPLAY_CALLS_DETAILS:
        // const isDisplayCallDetails = props.callsDetailsSubscribers.some(subscriber => subscriber.isDisplayCallDetails);
        // if(!isDisplayCallDetails){
        //   props.setCallsDetailsPopUp(true);
        // }
        const isGolan = process.env.staticWebSiteUrl?.includes('golan');
        if(isGolan){
          props.getCallsLogAuthAsync();
        }
        else if (props.callsDetailsSubscribers.length === 1 ) {
          props.getCallsLogAuthAsync(props.callsDetailsSubscribers[0]);
        } else {
          props.goToPage('callsDetailsPage_subscribers');
        }
        break;
      case IdentificationActionEnum.DISPLAY_TAX_INVOICE:
        props.getPdfLogAuthAsync({guidId: guid, systemSourcePDF});
        break;
      case IdentificationActionEnum.DISPLAY_ACCESSIBLE_INVOICE:
        props.getPdfLogAuthAsync({isAccessibilityInvoice: true, guidId: guid, systemSourcePDF});
        break;
      default:
        break;
    }
  }

  function handleOnCloseIdentificationPopUp() {
    props.closeIdentificationPopUp();
  }
  return (
    <>
      {props.detailsProducts?.length > 0 && (
        <div className='invoices-page'>
          <Header customerName={props.invoicesInfo?.main?.customerName} />
          <HeaderDateMonths isSticky={isSticky && !props.remark} isAuthorizationHeader={isAuthorizationHeader} />
          <>
            {props.isAdditionalMonths ? (
              <AdditionalInvoices handleOnClickButtonBar={handleOnClickButtonBar} />
            ) : (
              <React.Fragment>
                {isSticky && !props.remark && (
                  <ProductsSwiper
                    isSticky={isSticky}
                    isAuthorizationHeader={isAuthorizationHeader}
                    banList={props.banList}
                    selectedBan={props.selectedBan}
                    onClickBan={handleOnClickBan}
                  />
                )}
                {!props.remark && <ProductsSwiper banList={props.banList} selectedBan={props.selectedBan} onClickBan={handleOnClickBan} />}
                <div className='wrapper-components'>
                  <div className='container-components'>
                    <Updates messages={props.invoicesInfo?.dwMessage} initialOpenCount={1} />
                    {!props.remark && <ProductAccount />}
                    {!props.remark && (
                      <>
                        <DetailsMonthlyCharges
                          onClickUpdateMailing={handleOnClickUpdateMailing}
                          onClickPdfInvoice={handleOnClickButtonBar}
                        />
                        <ButtonBar handleOnClickButtonBar={handleOnClickButtonBar} />
                        <CallDetailsPopUp type={'WithoutService'} />
                      </>
                    )}
                    {props.remark && <div className='remark-message'>{props.remark}</div>}
                  </div>
                  <Footer context={props.context} iContent={props.iContent} isEnergy={props.isEnergy} />
                </div>
              </React.Fragment>
            )}
            <IdentificationPopUp onClickButton={handleOnClickIdentificationButton} onClose={handleOnCloseIdentificationPopUp} />
          </>
          <Popup
            className='annual-invoice-consolidation-popup'
            showPopUp={props.annualInvoiceConsolidation.showPopup}
            onClose={() => props.setShowAnnualInvoicePopup(false)}>
            <AnnualInvoiceConsolidationPopup
              annualInvoiceConsolidation={props.annualInvoiceConsolidation}
              setShowPopUp={props.setShowAnnualInvoicePopup}
            />
          </Popup>
          <Popup showPopUp={showIDPopup} onClose={() => setShowIDPopUp(false)} style={{background: 'white'}}>
            <IdValidationPopup setShowPopUp={setShowIDPopUp} closeModal={closeModalIdPopup} />
          </Popup>
        </div>
      )}
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    loginData: state.authentication.loginData,
    invoicesInfo: state.personalAreaInvoicesPage.invoicesInfo,
    isAdditionalMonths: state.personalAreaInvoicesPage.isAdditionalMonths,
    guidId: state.personalAreaInvoicesPage.guidId,
    banList: state.personalAreaInvoicesPage.banList,
    selectedBan: state.personalAreaInvoicesPage.selectedBan,
    epiData: state.personalAreaInvoicesPage.epiData,
    detailsProducts: state.personalAreaInvoicesPage.detailsProducts,
    callsDetailsSubscribers: state.personalAreaInvoicesPage.callsDetailsPage.subscribers,
    identificationPopUp: state.personalAreaInvoicesPage.identificationPopUp,
    authentication: state.authentication,
    annualInvoiceConsolidation: state.personalAreaInvoicesPage.annualInvoiceConsolidation,
    remark: state.personalAreaInvoicesPage.remark,
    isEnergy: state.personalAreaInvoicesPage.isEnergy,
  };
};
const mapDispatchToProps = {
  goToPage,
  getInvoiceDataBySectionSubscriberNoAsync,
  getInvoiceDataAsync,
  setGuidId,
  setSelectedBan,
  setDetailsProducts,
  setCallsDetailsPopUp,
  getPdfLogAuthAsync,
  getPdfAuthCheckLoginAsync,
  closeIdentificationPopUp,
  getCallsLogAuthAsync,
  setShowAnnualInvoicePopup,
};

export default connect(mapStateToProps, mapDispatchToProps)(InvoicesPage);
